export const toPrice = (price: number | string) => {
  if (typeof price === "string") {
    price = Number(price);
  }
  return typeof price === "number" ? price.toFixed(2) : price;
};
